define('app/sdc/file/icon/sdc-file-icon',["factory!sdc-file-type"], function (fileTypeFactory) {
	return {
		controller: {
			bind: {
				"fullType": "=?type"
			},
			constructor: ["$watch", "$self", function ($watch, vm) {
				$watch("vm.fullType", function (fullType) {
					vm.type = fileTypeFactory(fullType);
				});
			}]
		}
	};
});
